import React from "react"
import NotificationsListWidgetContainer from "./notifications-list/NotificationsListWidgetContainer"
import Notification from "./notification-item/Notification"
import pageComponentHoc from "../common/page-component-hoc"
import { notificationItemRequest } from "../../actions/notification-actions"

const Notifications = ({ isFilterActive }) => (
    <div className="widgets-container clearfix row">
        <div className="col-xs-12 col-md-6 col-lg-5 col-xl-4 widget-list">
            <NotificationsListWidgetContainer />
        </div>
        <Notification />
    </div>
)

export default pageComponentHoc(
    "notifications",
    notificationItemRequest
)(Notifications)
